/**
 * JWT keys in localStorage. Must match AuthContext.
 * Never use ``accessToken`` — that key is unused and sent ``Bearer undefined``.
 */

export const ACCESS_TOKEN_STORAGE_KEY = 'token';
export const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';

/**
 * Read the persisted access JWT, or an empty string.
 *
 * @returns {string}
 */
export const readStoredAccessToken = () => {
  if (typeof window === 'undefined') {
    return '';
  }
  try {
    return window.localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY) || '';
  } catch {
    return '';
  }
};

/**
 * Set or clear axios ``Authorization`` from an access token.
 *
 * @param {import('axios').AxiosStatic} client
 * @param {string} [access]
 */
export const syncAxiosAuth = (client, access) => {
  if (access) {
    client.defaults.headers.common.Authorization = `Bearer ${access}`;
  } else {
    delete client.defaults.headers.common.Authorization;
  }
};
